import React, { useState, useEffect, useContext } from "react";
import useForm from '../banner/customHooks';
import { X_TENANT_ID, THEME_URL, UPLOADIMAGE } from '../../common/ActionUrl'
import axios from 'axios';
import { AuthContext } from "../../common/Auth"
import SubscribeForm from './SubscribeForm';
import { _useToasts } from "../../common/_useToasts";
import { USERTYPES } from "../../constant/userType";

const Subscribe = ({ subscribeId, handleClose, fromEditAction }) => {

	const { user, userType, getThemeSettings } = useContext(AuthContext)

	const { inputs, handleInputChange, handleSubmit, resetColor, handleColorPicker, errors } = useForm({ title: "", description: "", btnText: "", btnHoverColor: "", btnHoverTextColor: "", btnColor: "", btnTextColor: "", image: "", paddingTop: "", paddingBottom: "", marginTop: "", marginBottom: "", paddingRight: "", paddingLeft: "", fullSection: false, marginLeft: "", marginRight: "" }, "", updateSubscribeCallback);

	const { _addToast } = _useToasts();
	const [subscribeData, SetSubscribeData] = useState({});
	const [isLoading, setIsLoading] = useState(false)
	const [tempImage, setTempImage] = useState("");
	const userId = user?.userId


	async function updateSubscribeCallback() {

		if (inputs.title && inputs.title.includes("<p>")) {
			inputs.title = inputs.title.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
			inputs.title = inputs.title.substr(0, inputs.title.length - 5);
		}

		if (inputs.description && inputs.description.includes("<p>")) {
			inputs.description = inputs.description.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
			inputs.description = inputs.description.substr(0, inputs.description.length - 5);
		}

		let insertData = {
			"values": {
				"title": inputs.title,
				"description": inputs.description,
				"btnText": inputs.btnText,
				"btnHoverColor": inputs.btnHoverColor,
				"btnHoverTextColor": inputs.btnHoverTextColor,
				"btnColor": inputs.btnColor,
				"btnTextColor": inputs.btnTextColor,
				"image": tempImage,
				"paddingTop": inputs.paddingTop,
				"paddingBottom": inputs.paddingBottom,
				"marginLeft": inputs.marginLeft,
				"marginRight": inputs.marginRight,
				"paddingRight": inputs.paddingRight,
				"paddingLeft": inputs.paddingLeft,
				"marginTop": inputs.marginTop,
				"marginBottom": inputs.marginBottom,
				"fullSection": inputs.fullSection,
			},
			"settingsName": "subscribe",
			userId
		}
		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
		};
		setIsLoading(true)
		if (subscribeId) {
			axios.patch(THEME_URL + subscribeId, insertData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {
						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});
					} else {
						getThemeSettings()
						handleClose()
					}
				}).catch(err => {
					console.log('err', err);
				});
		} else {
			axios.post(THEME_URL, insertData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {
						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});
					} else {
						getThemeSettings()
						handleClose()
					}
				}).catch(err => {
					console.log('err', err);
				});
		}
	}
	const getAbout = () => {
		setIsLoading(true)
		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
		};
		axios.get(THEME_URL + subscribeId, requestOptions)
			.then(res => {
				setIsLoading(false)
				if (res.data.error) {
					_addToast(res.data.message, {
						appearance: "error",
						autoDismiss: true
					});
				} else {
					if (res.data.settingsName === "subscribe") {
						SetSubscribeData(res.data.values[0])
					}
				}
			})
			.catch(err => {
				console.log('err', err);
			});
	}

	useEffect(() => {
		if (subscribeId) {
			getAbout()
		}
	}, [subscribeId])

	//its a temp value for update inputs value when edit banner
	const [value, setValue] = useState(0);
	useEffect(() => {
		if (Object.keys(subscribeData).length > 0) {
			inputs.title = subscribeData.title
			inputs.description = subscribeData.description
			inputs.btnText = subscribeData.btnText
			inputs.btnHoverColor = subscribeData.btnHoverColor
			inputs.btnHoverTextColor = subscribeData.btnHoverTextColor
			inputs.btnColor = subscribeData.btnColor
			inputs.btnTextColor = subscribeData.btnTextColor
			inputs.paddingTop = subscribeData.paddingTop
			inputs.paddingBottom = subscribeData.paddingBottom
			inputs.paddingRight = subscribeData.paddingRight
			inputs.paddingLeft = subscribeData.paddingLeft
			inputs.marginTop = subscribeData.marginTop
			inputs.marginBottom = subscribeData.marginBottom
			inputs.marginLeft = subscribeData.marginLeft
			inputs.marginRight = subscribeData.marginRight
			inputs.fullSection = subscribeData.fullSection
			setTempImage(subscribeData.image)
			setValue(value => value + 1);
		}
	}, [subscribeData])


	const deleteImage = (type) => {
		if (type === 'tempImage') {
			setTempImage("")
		}
	}

	const setImageFile = (event, type) => {
		const photoTarget = event.target.files[0];
		if (photoTarget.name.match(/\.(jpg|jpeg|png|gif|webp)$/)) {
			setIsLoading(true)
			const formData = new FormData();
			formData.append("file", photoTarget, photoTarget.name);

			const requestOptions = {
				headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
			};
			axios.post(UPLOADIMAGE, formData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {

						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});

					} else {
						if (res.data && res.data.Location != "") {
							if (type === 'image') {
								setTempImage(res.data.Location)
							}
						}
					}
				}).catch((error, config, code, request, response) => {
					setIsLoading(false)
					_addToast('Error while Uploded Image!', {
						appearance: "error",
						autoDismiss: true
					});

				});
		} else {
			setIsLoading(false)
			_addToast('Image type not allow', {
				appearance: "error",
				autoDismiss: true
			});
		}
	}
	return (
		<>
			<div className="contact-area pt-10 pb-10">
				{userType !== USERTYPES.USER ?
					<>
						<SubscribeForm
							isLoading={isLoading}
							inputs={inputs}
							handleSubmit={handleSubmit}
							handleInputChange={handleInputChange} errors={errors}
							handleColorPicker={handleColorPicker}
							subscribeId={subscribeId}
							handleClose={handleClose}
							fromEditAction={fromEditAction}
							setImageFile={setImageFile}
							deleteImage={deleteImage}
							tempImage={tempImage}
							resetColor={resetColor}
						/>
					</> : <h2>You haven't authority for update subscribe settings</h2>}
			</div>
		</>
	);
};

export default Subscribe;
